import Layout from '@/layout';
var channelRouter = {
  path: '/channel',
  component: Layout,
  redirect: '/channel/order',
  name: 'Channel',
  alwaysShow: true,
  meta: {
    title: '私域渠道',
    icon: 'clipboard'
  },
  children: [{
    path: 'order',
    component: function component() {
      return import('@/views/channel/order/index');
    },
    name: 'ChannelOrder',
    meta: {
      title: '渠道订单',
      icon: ''
    }
  }]
};
export default channelRouter;